exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#payment-terms[data-v-06e73fd0]{margin-top:80px}.page-title[data-v-06e73fd0]{margin-bottom:20px}.table th[data-v-06e73fd0]{border-top:none}.badge[data-v-06e73fd0]{font-size:.75em}.btn-group .btn[data-v-06e73fd0]{margin-right:2px}.btn-group .btn[data-v-06e73fd0]:last-child{margin-right:0}", ""]);

// exports
